/** @jsxImportSource @emotion/react */
import { FormControl, FormControlLabel } from '@mui/material';
import { createStyles, List, Checkbox } from '../../';

export interface Props {
  options: {
    value: string;
    label: string;
    disabled?: boolean;
  }[];
  onChange: (values: string[]) => void;
  values: string[];
}

export const CheckboxGroup = ({ options = [], onChange, values }: Props) => {
  const styles = useStyles();

  const handleChange = (value: string, checked: boolean) => {
    if (checked) {
      onChange([...values, value]);
    } else {
      onChange(values.filter((s) => s !== value));
    }
  };

  return (
    <FormControl fullWidth>
      <List>
        {options.map(({ value, label, disabled }) => (
          <li key={value}>
            <FormControlLabel
              value={value}
              control={
                <Checkbox
                  disabled={disabled}
                  onChange={(checked) => handleChange(value, checked)}
                  checked={values.includes(value)}
                />
              }
              label={label}
              disabled={disabled}
              css={styles.label}
            />
          </li>
        ))}
      </List>
    </FormControl>
  );
};

const useStyles = createStyles(({ spacing }) => ({
  label: {
    margin: '0',
    width: '100%',
    '.MuiCheckbox-root': {
      padding: spacing.xs,
    },
  },
}));
